import { getFieldsFromInstance } from '../core.utilidades/graphql-utils';

export class TipoEstado {

    id?: number;
    descripcion: string;
    
    constructor() {
        this.descripcion = '';
    }

    public static getFields = () => {
        return getFieldsFromInstance(new TipoEstado());
    };
}